module.exports = __webpack_public_path__ + "static/oskrds-86dbb9c4fa0b7be531c3842d9801df87.mp4";